import { IApiResponse } from '@/common/models/interface'
import api from '@/modules/api'
import { GupStatisticsMemberLevelRsp } from '@/services/models/GupStatistics'
import { AxiosResponse } from 'axios'

export default class GupStatisticService {
  public async getMemberLevels(): Promise<IApiResponse<GupStatisticsMemberLevelRsp[]>> {
    const res: AxiosResponse = await api.get('GupStatistic/MemberLevelToken')
    return res.data
  }
}
